<h2 mat-dialog-title class="order-log-title">LOG — {{ title }}</h2>
<mat-dialog-content class="order-log-dialog-content">
  <div class="related-invoices" *ngIf="relatedInvoices.length > 1">
    <div class="related-invoices-label">RELATED INVOICES:</div>
    <div class="related-invoices-list">
      <ng-container *ngFor="let related of relatedInvoices; let last = last">
        <button
          mat-button
          type="button"
          class="related-invoice-button"
          [class.current]="related.current"
          [disabled]="related.current"
          (click)="openRelated(related)"
        >
          {{ related.invoiceNumber }}
        </button>
        <span *ngIf="!last" class="related-invoice-sep">|</span>
      </ng-container>
    </div>
  </div>

  <mat-list role="list" dense>
    <mat-list-item *ngIf="!sortedLogs.length" role="listitem" class="order-log-row">
      <span class="log-row">NO LOG ENTRIES</span>
    </mat-list-item>
    <mat-list-item
      role="listitem"
      *ngFor="let log of sortedLogs"
      class="order-log-row"
    >
      <span class="log-row">
        {{ log.date | date: 'M/d/yy' }}
        <ng-container *ngIf="hasLogTime(log.date)">&nbsp;|&nbsp;{{ log.date | date: 'h:mm a' }}</ng-container>
        <ng-container *ngIf="log.initials">&nbsp;|&nbsp;{{ log.initials }}</ng-container>
        <ng-container *ngIf="log.item">&nbsp;|&nbsp;{{ formatLogItem(log.item) }}</ng-container>
        <ng-container *ngIf="log.notes">&nbsp;|&nbsp;{{ log.notes }}</ng-container>
      </span>
    </mat-list-item>
  </mat-list>
</mat-dialog-content>
